import * as React from "react";
import { InsuranceInfo } from "./InsuranceInfo";
import "./InsuranceInfoSummary.scss";
import InsuranceInformationItemsList from "../patient-management/InsuranceInformationItemsList";
import EditAction from "../commons/components/action/EditAction";

export default function InsuranceInfoSummary({
  forMyself,
  primaryInsuranceInfo,
  secondaryInsuranceInfo,
  editAction,
  showEditInsuranceForm,
}: {
  forMyself: boolean;
  primaryInsuranceInfo: InsuranceInfo;
  secondaryInsuranceInfo?: InsuranceInfo;
  editAction: boolean;
  showEditInsuranceForm: () => any;
}) {
  return (
    <div className="insurance-info-summary">
      <h2 className="panel-title h-flex space-between no-wrap">
        <div>{i18n["Page.Portal.InsuranceInformation.Title"]}</div>
        {editAction && <EditAction onClick={showEditInsuranceForm} />}
      </h2>
      <div>
        {editAction ? (
          primaryInsuranceInfo.hasInsurance ? (
            <>
              <InsuranceInformationItemsList
                insuranceInfo={primaryInsuranceInfo}
                title="Page.Portal.InsuranceInformation.PrimarySubTitle"
              />
              {secondaryInsuranceInfo && (
                <InsuranceInformationItemsList
                  insuranceInfo={secondaryInsuranceInfo}
                  title="Page.Portal.InsuranceInformation.SecondarySubTitle"
                />
              )}
            </>
          ) : (
            <div>
              <span>{i18n["Page.Portal.InsuranceInformation.DontHaveInsurance"]}</span>
            </div>
          )
        ) : (
          <div className={"h-flex centered action-container"}>
            <button className="button-secondary small" onClick={showEditInsuranceForm}>
              {
                i18n[
                  forMyself
                    ? "Page.Portal.InsuranceInformation.CompleteInformation.ForMyself.Button"
                    : "Page.Portal.InsuranceInformation.CompleteInformation.Button"
                ]
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
